export default __webpack_public_path__ + "swim-safety-profiles-yellow-transparent.svg";